import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgClass, NgFor } from '@angular/common';
import { HasPermissionDirective } from '../../../auth/directives/has-permission.directive';

export interface BeyMenuOption {
  label: string;
  onClick: Function;
  color?: 'red';
  permissions?: Array<string>;
}

@Component({
  selector: 'bey-menu',
  templateUrl: './bey-menu.component.html',
  styleUrls: ['./bey-menu.component.scss'],
  standalone: true,
  imports: [NgClass, NgFor, HasPermissionDirective],
})
export class BeyMenuComponent implements OnInit {
  /****
   * the options that will be displayed inside the menu
   */
  @Input()
  options: Array<BeyMenuOption> = [];

  /****
   * indicates if the menu is opened
   */
  @Input()
  opened: boolean;

  @Output()
  itemSelected: EventEmitter<BeyMenuOption> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  onSelect(option: BeyMenuOption) {
    option.onClick();
  }
}
